import React, { useEffect } from 'react';
import ModalManager from './modal-manager.esm.js';
import ShareContext from './share-context.esm.js';

var GLOBAL_MODAL_MANAGER = 'csg-global-modal-context';
var ModalContextProvider = function ModalContextProvider(props) {
  var _props$contextId = props.contextId,
    contextId = _props$contextId === void 0 ? GLOBAL_MODAL_MANAGER : _props$contextId,
    children = props.children;
  useEffect(function () {
    if (!ShareContext.getContext(contextId)) {
      var context = {
        manager: new ModalManager()
      };
      // modal manager is a singleton that will persist through out the life cycle of the browser app
      ShareContext.registerGlobalContext(contextId, context);
    }
    return function () {
      ShareContext.unregisterGlobalContext(contextId);
    };
  }, [contextId]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
function useModalContext() {
  var retVal = ShareContext.getContext(GLOBAL_MODAL_MANAGER);
  return retVal;
}

export { ModalContextProvider, useModalContext };
//# sourceMappingURL=modal-context.esm.js.map
